// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-label {\n  top: 10px;\n}\n.modal-text {\n  font-size: 20px;\n  font-weight: 600;\n}\n.modal-select {\n  height: 40px;\n  border-radius: 10px;\n}\n:deep(.remark) {\n  color: red;\n  margin-bottom: 3px;\n  font-size: 13px;\n  text-align: left;\n  line-height: 16px;\n}\n.modal-footer {\n  flex-wrap: nowrap;\n}\n.time-alert {\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
